import script from "./purchaseRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./purchaseRequest.vue?vue&type=script&setup=true&lang=js"

import "./purchaseRequest.vue?vue&type=style&index=0&id=205bc711&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-205bc711"]])

export default __exports__